export const actionTypes = {
  ADD_PACKAGE: 'ADD_PACKAGE',
  UPDATE_OPTIONS_SELECTED: 'UPDATE_OPTIONS_SELECTED',
};

const addPackage = (packages) => ({
  type: actionTypes.ADD_PACKAGE,
  packages,
});

const updateOptionsSelected = (optionsSelected) => ({
  type: actionTypes.UPDATE_OPTIONS_SELECTED,
  optionsSelected,
});

export { addPackage, updateOptionsSelected };
